// import { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

// import supportSelectors from '@/redux/support/supportSelectors';

// import supportOperations from '@/redux/support/supportOperations';

import RouteNames from '@/router/routes';

import NotificationIcon from '@/images/notification.svg?react';

import s from './btnNotification.module.css';

function BtnNotification() {
  // const dispatch = useDispatch();

  // const countUnreadTickets = useSelector(supportSelectors.countUnreadMessages);

  // useEffect(() => {
  //   dispatch(supportOperations.getTickets());

  //   const repeatedAction = setInterval(() => {
  //     dispatch(supportOperations.getTickets());
  //   }, 60000);

  //   return () => clearInterval(repeatedAction);
  // }, [dispatch]);

  return (
    <Link to={`/${RouteNames.NOTIFICATIONS}`} className={s.btn_notification}>
      <NotificationIcon />
      {/* {!!countUnreadTickets && <p>{countUnreadTickets}</p>} */}
    </Link>
  );
}

export default BtnNotification;
